import { GameProviderDailyReportEntityService } from '@views/pages/apps/reports/game-provider-report/services/game-provider-daily-report-entity.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';

@Injectable()
export class GameProviderDailyReportResolver implements Resolve<boolean> {

    constructor(private gameProviderDailyReportEntityService: GameProviderDailyReportEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.gameProviderDailyReportEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.gameProviderDailyReportEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
